import { MapPlace } from "./MapPlace";
import { Sector } from "./Sector";

export enum MapView {
  PLACES = 'places',
  CART = 'cart',
  TICKETS = 'tickets'
}

export interface Map {
  id: string;
  eventId: string;
  image: string;
  imageSectors: string;
  color: string;
  places: MapPlace[];
  sectors: Sector[]
}